import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetStoreClassesMutationVariables = Types.Exact<{
  input: Types.SetStoreClassesInput;
}>;


export type SetStoreClassesMutation = { __typename?: 'Mutation', setStoreClasses: { __typename?: 'StoreClassPayload', state?: { __typename?: 'StoreClassStateData', storeClasses: Array<{ __typename?: 'StoreClassEntryStateData', class: string, rank: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SetStoreClassesDocument = new TypedDocumentString(`
    mutation SetStoreClasses($input: SetStoreClassesInput!) {
  setStoreClasses(input: $input) {
    state {
      storeClasses {
        class
        rank
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetStoreClasses: build.mutation<SetStoreClassesMutation, SetStoreClassesMutationVariables>({
      query: (variables) => ({ document: SetStoreClassesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetStoreClassesMutation } = injectedRtkApi;
